module.exports = __webpack_public_path__ + "static/media/entregado.ab8370b2.svg";